<template>
  <v-layout
    :wrap="$vuetify.breakpoint.mdAndDown"
    fill-height
  >
    <v-flex
      xs12
      :lg8="showGiftgiverSection"
    >
      <v-layout
        class="family-card-info"
        :wrap="smAndDownScreen"
        fill-height
      >
        <v-flex
          v-bind="sectionOneAttributes"
          class="family-card-info_bordered"
          :class="[smAndDownScreen ? 'pb-3' : 'pr-4']"
        >
          <v-layout class="family-card-info__item">
            <v-flex
              v-bind="keyAttributes"
              class="pr-3 family-card-info__key"
            >
              {{ $t('family_card.base_data.code') | addColons }}
            </v-flex>
            <v-flex
              v-bind="valuesAttributes"
              align-self-center
            >
              {{ family.family_code }}
            </v-flex>
          </v-layout>
          <v-layout class="family-card-info__item">
            <v-flex
              v-bind="keyAttributes"
              class="pr-3 family-card-info__key"
            >
              {{ $t('family_card.base_data.representative') | addColons }}
            </v-flex>
            <v-flex
              v-bind="valuesAttributes"
              class="fw-600"
              align-self-center
            >
              {{ family.first_name }} {{ family.last_name }}
            </v-flex>
          </v-layout>
          <v-layout class="family-card-info__item mt-3">
            <v-flex
              v-bind="keyAttributes"
              class="pr-3 family-card-info__key"
            >
              {{ $t('family_card.base_data.address') | addColons }}
            </v-flex>
            <v-flex v-bind="valuesAttributes">
              {{ fullStreet }} {{ family.postal_code | postalCode }} {{ family.city }}
            </v-flex>
          </v-layout>
          <v-layout
            v-if="showPhoneNumber"
            class="family-card-info__item"
          >
            <v-flex
              v-bind="keyAttributes"
              class="pr-3 family-card-info__key"
            >
              {{ $t('family_card.base_data.phone') | addColons }}
            </v-flex>
            <v-flex v-bind="valuesAttributes">
              <v-layout wrap>
                <v-flex
                  v-for="(phone, index) in family.phones"
                  :key="index"
                  xl10
                  md7
                  sm7
                  xs6
                >
                  <PhoneNumber :number="phone.number" />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout class="family-card-info__item">
            <v-flex
              v-bind="keyAttributes"
              class="pr-3 family-card-info__key"
            >
              {{ $t('family_card.base_data.area') | addColons }}
            </v-flex>
            <v-flex
              v-bind="valuesAttributes"
              align-self-center
            >
              {{ family.location_name }}
              <a
                v-if="canChangeRegion && !isFamilyDisabled"
                class="small fw-400"
                @click="changeRegion"
              >
                {{ $t('buttons.change_region') }}
              </a>
            </v-flex>
          </v-layout>
          <v-layout
            v-if="showWarehouseSection"
            class="family-card-info__item"
          >
            <v-flex
              v-bind="keyAttributes"
              class="pr-3 family-card-info__key"
            >
              {{ $t('family_card.base_data.warehouse') | addColons }}
            </v-flex>
            <v-flex v-bind="valuesAttributes">
              <p
                v-if="nativeWarehouse"
                class="mb-0"
              >
                <span class="fw-600 d-block">{{ $t('label.native_warehouse') | addColons }}</span>
                {{ nativeWarehouse.warehouse_name }}
              </p>
              <p
                v-if="supportingWarehouses.length > 0"
                class="mb-0 f-14"
              >
                <span class="fw-600 d-block">{{
                  $t('label.available_in_warehouses') | addColons
                }}</span>
                <span
                  v-for="(item, index) in supportingWarehouses"
                  :key="index"
                  class="d-block"
                >{{
                  item.warehouse_name | beforeSpace
                }}</span>
              </p>
              <p
                v-if="chosenWarehouse"
                class="mb-0 f-2"
              >
                <span class="fw-600 d-block">{{
                  $t('label.chosen_in_warehouses') | addColons
                }}</span>
                {{ chosenWarehouse.warehouse_name }}
              </p>
            </v-flex>
          </v-layout>
          <v-layout
            v-if="canEditFamilyData"
            justify-center
            class="mt-3"
          >
            <v-btn
              id="editFamilyDataModal"
              color="sz_violet"
              class="mr-0 text-xs-center"
              @click="editDataDialog = true"
            >
              {{ $t('buttons.edit') }}
            </v-btn>
            <EditFamilyDataModal
              :edit-data-dialog="editDataDialog"
              :family="family"
              :privileged="canPrivilegedEditFamilyData"
              @close="editDataDialog = false"
              @reload="reloadAction()"
            />
          </v-layout>
        </v-flex>
        <v-flex
          v-bind="sectionTwoAttributes"
          :class="[smAndDownScreen ? 'mt-3' : 'pl-4']"
        >
          <v-layout
            class="family-card-info__item"
            wrap
          >
            <v-flex xs12>
              <v-layout wrap>
                <v-flex
                  shrink
                  class="pr-2 family-card-info__key none-growth"
                >
                  {{ $t('family_card.base_data.status') | addColons }}
                </v-flex>
                <v-flex shrink>
                  <FamilyStatus
                    :mobile="false"
                    :status="family.status"
                  />
                  <v-flex
                    v-if="isRevokePublication"
                    shrink
                    class="text-xs-center"
                    @click="revokePublication"
                  >
                    <a>{{ $t('buttons.revoke_publication') }}</a>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              v-if="!isCurrentEdition"
              xs12
            >
              <v-layout wrap>
                <v-flex
                  v-bind="keyAttributes"
                  class="pr-3 family-card-info__key none-growth"
                >
                  <span>{{ $t('label.edition') | addColons }}</span>
                </v-flex>
                <v-flex
                  v-bind="valuesAttributes"
                  align-self-center
                >
                  <p class="mb-0 pl-3">
                    {{ family.edition.name }}
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              xs12
              mt-3
              mb-2
            >
              <v-layout
                v-if="isCurrentEdition && toAcceptForVulunteer && isPrimaryVolunteer"
                class="text-xs-center"
              >
                <v-flex
                  shrink
                  class="mr-3"
                >
                  <v-layout>
                    <v-flex @click="acceptFamily()">
                      <a
                        class="link_iconed"
                        style="font-size: 16px"
                      >
                        <v-icon
                          color="#00BB62"
                          class="mr-1 fab-links bg_green"
                          :width="16"
                          :height="16"
                        >check</v-icon>
                        {{ $t('buttons.accept') }}
                      </a>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink>
                  <v-layout>
                    <v-flex @click="rejectFamily()">
                      <a
                        class="link_iconed"
                        style="font-size: 16px"
                      >
                        <BaseIcon
                          width="20"
                          height="20"
                          class="mr-1 fab-links bg_red"
                          style="border-radius: 100%"
                        >
                          <CloseIcon color="#ED1C24" />
                        </BaseIcon>
                        {{ $t('buttons.reject') }}
                      </a>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <revokeFamilyDialog
          :show="revokePublicationDialog"
          @show="revokePublicationDialog = $event"
        />
        <manageRegionDialog
          v-if="canChangeRegion && !isFamilyDisabled"
          :show="manageRegion"
          :item="family"
          @show="manageRegion = $event"
        />
        <refuseReasonDialog
          v-if="toAcceptForVulunteer && isPrimaryVolunteer"
          :item="family"
          :show="isRefuseFamily"
          @remove-item="removeRefused()"
          @show="isRefuseFamily = $event"
        />
      </v-layout>
    </v-flex>
    <v-flex
      v-if="showGiftgiverSection"
      lg4
      :class="{ 'pl-3': $vuetify.breakpoint.lgAndUp, 'mt-3': $vuetify.breakpoint.mdAndDown }"
    >
      <v-layout
        wrap
        class="family-card-info text-dark"
        fill-height
      >
        <v-flex xs12>
          <p class="family-card-info__key mb-1">
            {{ $t('family_card.base_data.giftgiver') | addColons }}
          </p>
          <p class="mb-0 f-1 fw-600">
            {{ giftgiverName }}
          </p>
          <v-divider class="my-3" />
          <v-layout
            v-if="giftgiverPhone"
            align-center
          >
            <v-flex class="none-growth mr-2">
              <v-icon>phone</v-icon>
            </v-flex>
            <v-flex><PhoneNumber :number="giftgiverPhone" /></v-flex>
          </v-layout>
          <v-layout
            v-if="giftgiverEmail"
            align-center
            class="mt-2"
          >
            <v-flex class="none-growth mr-2">
              <v-icon>mail_outline</v-icon>
            </v-flex>
            <v-flex><BaseEmail :email="giftgiverEmail" /></v-flex>
          </v-layout>
          <v-layout
            v-if="giftgiverFormOfContact"
            align-center
            wrap
            class="mt-2"
          >
            <v-flex xs12>
              <p class="fw-600 mt-2 mb-1">
                {{ $t('family_card.base_data.form_of_contact') | addColons }}
              </p>
            </v-flex>
            <v-flex xs12>
              {{ giftgiverFormOfContact }}
            </v-flex>
          </v-layout>
          <v-layout
            v-if="giftgiverCategory"
            align-center
            wrap
            class="mt-2"
          >
            <v-flex xs12>
              <p class="fw-600 mt-2 mb-1">
                {{ $t('family_card.base_data.category') | addColons }}
              </p>
            </v-flex>
            <v-flex xs12>
              {{ giftgiverCategory }}
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout
            justify-center
            :wrap="$vuetify.breakpoint.lgAndDown"
          >
            <v-flex class="none-growth">
              <v-layout
                justify-center
                wrap
              >
                <v-btn
                  v-if="isCurrentEdition && (canAssignGiftgiver || canEditGiftgiverData)"
                  :id="manageGiftgiverButtonId"
                  color="sz_violet"
                  class="mt-3"
                  :disabled="disabledAssignGiftGiverButton"
                  @click="openAssignGiftgiverModal()"
                >
                  {{ manageGiftgiverButtonTitle }}
                </v-btn>
                <p
                  v-if="isCurrentEdition && disabledAssignGiftGiverButton"
                  class="mb-0 link_iconed sz_red--text"
                >
                  <v-icon
                    color="sz_red"
                    class="mr-2"
                  >
                    error_outline
                  </v-icon>
                  {{ $t('message.publish_warehouse') }}
                </p>
              </v-layout>
              <AppModal
                :visible="showAssignGiftgiverModal"
                @close="closeAssignGiftgiverModal()"
              >
                <template slot="title">
                  <h2 class="display-3 display-3_dark">
                    {{ $t('giftgiver.assign.title') }}
                  </h2>
                </template>
                <template slot="content">
                  <AssignGiftgiverForm
                    ref="assignGiftgiverForm"
                    :warehouses="family.warehouses"
                    :has-giftgiver="family.gift_giver != null"
                    :can-edit-giftgiver-data="canEditGiftgiverData"
                  />
                </template>
                <template slot="actions">
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-divider class="mb-3" />
                    </v-flex>
                    <v-flex xs12>
                      <v-layout
                        justify-end
                        :justify-center="$vuetify.breakpoint.xsOnly"
                      >
                        <v-flex shrink>
                          <v-btn
                            color="sz_violet"
                            v-bind="sendGiftgiverDataButtonId"
                            :loading="assignGiftgiverLoader"
                            @click="manageGiftgiver()"
                          >
                            {{ canEditGiftgiverData ? $t('buttons.save') : $t('buttons.send') }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </template>
              </AppModal>
            </v-flex>
            <v-flex class="none-growth">
              <v-btn
                v-if="canRemoveGiftgiver"
                id="removeGiftGiverModal"
                color="sz_violet"
                class="mt-3"
                @click="openRemoveGiftgiverModal()"
              >
                {{ $t('buttons.remove_giftgiver') }}
              </v-btn>
              <AppModal
                :visible="showRemoveGiftgiverModal"
                @close="closeRemoveGiftgiverModal()"
              >
                <template slot="title">
                  <h2 class="display-3 display-3_dark">
                    {{ $t('giftgiver.remove.title') }}
                  </h2>
                </template>
                <template slot="content">
                  <RemoveGiftgiverForm ref="removeGiftgiverForm" />
                </template>
                <template slot="actions">
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-divider class="mb-3" />
                    </v-flex>
                    <v-flex xs12>
                      <v-layout
                        justify-end
                        :justify-center="$vuetify.breakpoint.xsOnly"
                      >
                        <v-flex shrink>
                          <v-btn
                            id="removeGiftGiver"
                            color="sz_violet"
                            :loading="removeGiftgiverLoader"
                            @click="removeGiftgiver()"
                          >
                            {{ removeGiftgiverButtonTitle }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </template>
              </AppModal>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
// @TODO: refactor, this component has way to much logic / lines of code for what it is doing
// NP-3038
import AssignGiftgiverForm from '@/components/giftgiver/AssignGiftgiverForm';
import RemoveGiftgiverForm from '@/components/giftgiver/RemoveGiftgiverForm';
import BaseEmail from '@/components/widgets/BaseEmail.vue';
import AppModal from '@/components/widgets/AppModal';
import PhoneNumber from '@/components/widgets/PhoneNumber.vue';
import EditFamilyDataModal from '@/components/widgets/addFamily/EditFamilyDataModal';
import FamilyStatus from '@/components/widgets/dataTable/FamilyStatus';
import ManageRegionDialog from '@/components/widgets/dataTable/manageRegionDialog';
import refuseReasonDialog from '@/components/widgets/dataTable/refuseReasonDialog';
import revokeFamilyDialog from '@/components/widgets/dataTable/revokeFamilyDialog';
import filters from '@/constants/filters';
import BaseIcon from '@/icons/BaseIcon';
import CloseIcon from '@/icons/CloseIcon';

import permissions from '@/constants/permissions';
import statusesId from '@/constants/statusesId';

import familyWarehouses from '@/mixins/familyWarehouses';

export default {
    name: 'BaseFamilyData',
    components: {
        ManageRegionDialog,
        FamilyStatus,
        BaseIcon,
        CloseIcon,
        refuseReasonDialog,
        EditFamilyDataModal,
        revokeFamilyDialog,
        AppModal,
        AssignGiftgiverForm,
        RemoveGiftgiverForm,
        PhoneNumber,
        BaseEmail
    },
    filters: {
        ...filters
    },
    mixins: [familyWarehouses],
    props: {
        toAcceptForVulunteer: {
            type: Boolean,
            default: false
        },
        hasPermissionChangeWio: {
            default: false
        }
    },
    data () {
        return {
            permissions,
            statusesId,
            isRefuseFamily: false,
            manageRegion: false,
            hasPermissionForAssignedFamily: null,
            hasPermissionForFamily: null,
            hasEditPermission: null,
            updatePrivilegedPermission: null,
            editDataDialog: false,
            revokePublicationDialog: false,
            hasPermissionRevokePublication: false,
            hasPermissionForAssigningGiftgiver: null,
            showAssignGiftgiverModal: false,
            assignGiftgiverLoader: false,
            hasPermissionForRemovingGiftgiver: null,
            showRemoveGiftgiverModal: false,
            removeGiftgiverLoader: false,
            hasPermissionForGiftgiverEdit: null,
            WAREHOUSE_PUBLISHED_STATUS_ID: 20
        };
    },
    computed: {
        family () {
            return this.$store.getters['family/getFamily'];
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        smAndDownScreen () {
            return this.$vuetify.breakpoint.smAndDown;
        },
        availableStatusesForShowGiftGiverSection () {
            return [this.statusesId.PUBLISHED, this.statusesId.PUBLICATION_REVOKED];
        },
        fullStreet () {
            const street = this.family.street ? this.family.street : '';
            const _flat = this.family.flat_number !== null ? '/' + this.family.flat_number : '';
            return street + ' ' + this.family.building_number + _flat;
        },
        showPhoneNumber () {
            return (
                this.family !== null && this.family.phones !== undefined && this.family.phones.length > 0
            );
        },
        isPrimaryVolunteer () {
            return (
                this.family.primary_volunteer !== null &&
        this.family.primary_volunteer.id === this.$store.getters['auth/getUser'].id
            );
        },
        noVolunteers () {
            return this.family.primary_volunteer == null && this.family.secondary_volunteer == null;
        },
        canChangeRegion () {
            return this.isCurrentEdition && this.noVolunteers && this.hasPermissionChangeWio === true;
        },
        featuresVisible () {
            return this.$store.getters.featuresVisible;
        },
        isFamilyDisabled () {
            return this.family.status.family_edition_status_id === 3;
        },
        canEditFamilyData () {
            if (this.canPrivilegedEditFamilyData) {
                return true;
            }
            return this.isCurrentEdition && this.hasEditPermission && this.family.is_allowed_to_edit;
        },
        canPrivilegedEditFamilyData () {
            return this.isCurrentEdition && this.updatePrivilegedPermission;
        },
        hasGiftGiverAndHigherStatus () {
            const statuses = [
                this.statusesId.HAS_GIFTGIVER,
                this.statusesId.GIFT_GIVING_REPORT_DESCRIBED,
                this.statusesId.GIFT_GIVING_REPORT_CHECKING,
                this.statusesId.GIFT_GIVING_REPORT_SEND
            ];
            return statuses.includes(this.family.status.family_edition_status_id);
        },
        showGiftgiverSection () {
            return (
                this.family.gift_giver != null ||
        this.availableStatusesForShowGiftGiverSection.includes(
            this.family.status.family_edition_status_id
        )
            );
        },
        keyAttributes () {
            if (this.showGiftgiverSection) {
                return {
                    xl3: true,
                    md5: true,
                    sm5: true,
                    xs6: true
                };
            } else {
                return {
                    xl2: true,
                    md5: true,
                    sm5: true,
                    xs6: true
                };
            }
        },
        valuesAttributes () {
            if (this.showGiftgiverSection) {
                return {
                    xl9: true,
                    md5: true,
                    sm5: true,
                    xs6: true
                };
            } else {
                return {
                    xl10: true,
                    md7: true,
                    sm7: true,
                    xs6: true
                };
            }
        },
        sectionOneAttributes () {
            if (this.showGiftgiverSection) {
                return {
                    lg8: true,
                    md7: true,
                    sm12: true
                };
            } else {
                return {
                    md6: true,
                    sm12: true
                };
            }
        },
        sectionTwoAttributes () {
            if (this.showGiftgiverSection) {
                return {
                    lg4: true,
                    md5: true,
                    sm12: true
                };
            } else {
                return {
                    md6: true,
                    sm12: true
                };
            }
        },
        giftgiverName () {
            return this.family.gift_giver != null
                ? `${this.family.gift_giver.first_name} ${this.family.gift_giver.last_name}`
                : '';
        },
        giftgiverEmail () {
            return this.family.gift_giver != null ? this.family.gift_giver.email : '';
        },
        giftgiverPhone () {
            return this.family.gift_giver != null ? this.family.gift_giver.phone_number : '';
        },
        giftgiverFormOfContact () {
            return this.family.gift_giver != null && this.family.gift_giver.comment != null
                ? this.family.gift_giver.comment
                : '';
        },
        giftgiverCategory () {
            return this.family?.gift_giver != null ? this.family.gift_giver.category.description : '';
        },
        isRevokePublication () {
            if (this.isCurrentEdition !== true) {
                return false;
            }
            return (
                this.family &&
        this.family.status.family_edition_status_id === this.statusesId.PUBLISHED &&
        this.hasPermissionRevokePublication
            );
        },
        canAssignGiftgiver () {
            return this.family.gift_giver === null && this.hasPermissionForAssigningGiftgiver;
        },
        isWarehousePublished () {
            return this.family.warehouses?.some((el) => {
                return el?.status?.warehouse_status_id === this.WAREHOUSE_PUBLISHED_STATUS_ID;
            }) ?? false;
        },
        disabledAssignGiftGiverButton () {
            return (
                !(this.canAssignGiftgiver && this.isWarehousePublished) &&
        !this.canEditGiftgiverData &&
        !this.isWarehousePublished
            );
        },
        statusesForRemoveGiftGiver () {
            return [
                this.statusesId.HAS_GIFTGIVER,
                this.statusesId.GIFT_GIVING_REPORT_DESCRIBED,
                this.statusesId.GIFT_GIVING_REPORT_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_NATIONAL_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_NATIONAL_REACH
            ];
        },
        canRemoveGiftgiver () {
            if (this.isCurrentEdition !== true) {
                return false;
            }
            return (
                this.family.gift_giver != null &&
        this.hasPermissionForRemovingGiftgiver &&
        this.statusesForRemoveGiftGiver.includes(this.family.status.family_edition_status_id)
            );
        },
        removeGiftgiverButtonTitle () {
            return this.$vuetify.breakpoint.xs
                ? this.$t('buttons.remove_giftgiver')
                : this.$t('buttons.remove_giftgiver_and_publish');
        },
        canEditGiftgiverData () {
            return this.family.gift_giver != null && this.hasPermissionForGiftgiverEdit;
        },
        manageGiftgiverButtonId () {
            if (this.canAssignGiftgiver) {
                return 'assignGiftGiverModal';
            }
            if (this.canEditGiftgiverData) {
                return 'editGiftGiverModal';
            }
            return '';
        },
        sendGiftgiverDataButtonId () {
            if (this.canAssignGiftgiver) {
                return { id: 'assignGiftGiver' };
            }
            if (this.canEditGiftgiverData) {
                return { id: 'editGiftGiver' };
            }
            return false;
        },
        manageGiftgiverButtonTitle () {
            if (this.canAssignGiftgiver) {
                return this.$t('buttons.assign_giftgiver');
            }
            if (this.canEditGiftgiverData) {
                return this.$t('buttons.edit_data');
            }
            return '';
        },
        showWarehouseSection () {
            return this.nativeWarehouse || this.supportingWarehouses.length > 0 || this.chosenWarehouse;
        }
    },
    created () {
        this.$store
            .dispatch('auth/hasPermission', this.permissions.ASSIGNED_FAMILY_EDITION_VIEW)
            .then((res) => {
                this.hasPermissionForAssignedFamily = res;
            });
        this.$store.dispatch('auth/hasPermission', this.permissions.FAMILY_EDITION_VIEW).then((res) => {
            this.hasPermissionForFamily = res;
        });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.FAMILY_EDITION_EDIT)
            .then((result) => {
                this.hasEditPermission = result;
            });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.PRIVILEGED_FAMILY_EDITION_EDIT)
            .then((result) => {
                this.updatePrivilegedPermission = result;
            });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.REVOKE_FAMILY_PUBLICATION)
            .then((result) => {
                this.hasPermissionRevokePublication = result;
            });
        this.$store.dispatch('auth/hasPermission', this.permissions.GIFTGIVER_ASSIGN).then((result) => {
            this.hasPermissionForAssigningGiftgiver = result;
        });
        this.$store.dispatch('auth/hasPermission', this.permissions.GIFTGIVER_REMOVE).then((result) => {
            this.hasPermissionForRemovingGiftgiver = result;
        });
        this.$store.dispatch('auth/hasPermission', this.permissions.GIFTGIVER_EDIT).then((result) => {
            this.hasPermissionForGiftgiverEdit = result;
        });
    },
    methods: {
        rejectFamily () {
            this.isRefuseFamily = true;
        },
        reloadAction () {
            this.$emit('reload');
        },
        acceptFamily () {
            this.$store
                .dispatch('volunteers/acceptFamily', { id: this.family.family_edition_id })
                .then((data) => {
                    this.reloadAction();
                    this.$store.dispatch('sheet/getSheetPermissions', this.family.family_edition_id);
                });
        },
        removeRefused () {
            if (this.hasPermissionForFamily) {
                this.$store.dispatch('family/getFamily', {
                    id: this.family.family_edition_id,
                    endpointLabel: 'family'
                });
            } else if (this.hasPermissionForAssignedFamily) {
                this.$router.push({ name: 'families-to-accept' });
            }
        },
        changeRegion () {
            this.manageRegion = true;
        },
        revokePublication () {
            this.revokePublicationDialog = true;
        },
        openAssignGiftgiverModal () {
            this.showAssignGiftgiverModal = true;
        },
        openRemoveGiftgiverModal () {
            this.showRemoveGiftgiverModal = true;
        },
        closeAssignGiftgiverModal () {
            this.showAssignGiftgiverModal = false;
            if (this.canAssignGiftgiver) {
                this.clearAssignGiftgiverData();
            }
            this.clearAssignGiftgiverValidatorFlags();
        },
        closeRemoveGiftgiverModal () {
            this.showRemoveGiftgiverModal = false;
            this.clearRemoveGiftgiverData();
            this.clearRemoveGiftgiverValidatorFlags();
        },
        clearAssignGiftgiverValidatorFlags () {
            Object.keys(this.$refs.assignGiftgiverForm.$validator.flags).forEach(async (x) => {
                this.$refs.assignGiftgiverForm.$validator.flags[x].invalid = false;
                this.$refs.assignGiftgiverForm.$validator.flags[x].valid = true;
                this.$refs.assignGiftgiverForm.$validator.flags[x].changed = false;
                await this.$nextTick();
                this.$refs.assignGiftgiverForm.$validator.errors.clear();
            });
        },
        clearRemoveGiftgiverValidatorFlags () {
            Object.keys(this.$refs.removeGiftgiverForm.$validator.flags).forEach(async (x) => {
                this.$refs.removeGiftgiverForm.$validator.flags[x].invalid = false;
                this.$refs.removeGiftgiverForm.$validator.flags[x].valid = true;
                this.$refs.removeGiftgiverForm.$validator.flags[x].changed = false;
                await this.$nextTick();
                this.$refs.removeGiftgiverForm.$validator.errors.clear();
            });
        },
        clearAssignGiftgiverData () {
            this.$store.commit('giftgiver/resetGiftgiverData');
        },
        clearRemoveGiftgiverData () {
            this.$store.commit('giftgiver/clearRemoveGiftgiverData');
        },
        assignGiftgiver (_data) {
            this.$store
                .dispatch('giftgiver/assingGiftgiver', _data)
                .then((response) => {
                    this.finalManageActions(response);
                })
                .catch(() => {
                    this.$toast(this.$t('giftgiver.assign.toast'));
                })
                .finally(() => {
                    this.assignGiftgiverLoader = false;
                });
        },
        editGiftgiverData (_data) {
            this.$store
                .dispatch('giftgiver/editGiftgiver', _data)
                .then((response) => {
                    this.finalManageActions(response);
                })
                .finally(() => {
                    this.assignGiftgiverLoader = false;
                });
        },
        finalManageActions ({ data }) {
            this.$store.commit('family/setFamily', data?.data);
            this.closeAssignGiftgiverModal();
        },
        manageGiftgiver () {
            this.$refs.assignGiftgiverForm.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.assignGiftgiverLoader = true;
                    const _data = {
                        id: this.family.family_edition_id,
                        data: this.$store.getters['giftgiver/getGiftgiverData']
                    };
                    if (this.canAssignGiftgiver) {
                        this.assignGiftgiver(_data);
                    }
                    if (this.canEditGiftgiverData) {
                        if (_data.data.chosen_warehouse) {
                            delete _data.data.chosen_warehouse;
                        }
                        _data.data.explanation = this.$store.getters['giftgiver/getExplanation'];
                        _data.data.phone_number = _data.data.phone_number.replace(' ', '');
                        this.editGiftgiverData(_data);
                    }
                }
            });
        },
        removeGiftgiver () {
            this.$refs.removeGiftgiverForm.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.removeGiftgiverLoader = true;
                    const _data = {
                        id: this.family.family_edition_id,
                        data: {
                            ...this.$store.getters['giftgiver/getRemoveGiftgiverData']
                        }
                    };
                    this.$store
                        .dispatch('giftgiver/removeGiftgiver', _data)
                        .then(({ data }) => {
                            this.$store.commit('family/setFamily', data?.data);
                            this.$store.commit('giftgiver/resetGiftgiverData');
                            this.clearAssignGiftgiverValidatorFlags();
                            this.closeRemoveGiftgiverModal();
                        })
                        .catch(() => {
                            this.$toast(this.$t('giftgiver.remove.toast'));
                        })
                        .finally(() => {
                            this.removeGiftgiverLoader = false;
                        });
                }
            });
        }
    }
};
</script>

<style scoped></style>
